import { useEffect, useMemo, useRef, useState } from 'react'

const norm = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

// Comercial's own copy of components/ot/AsignarA (kept apart so neither module
// changes the other). "+ Asignar a…": a box that opens a list grouped by kind and narrows as you
// type (accents and case ignored). groups: [{ label, options: [{ value, label }] }].
// The list is fixed-positioned so a table's overflow never clips it.
export default function ComercialAsignarA({ groups, placeholder, vacio, onPick }) {
  const [q, setQ] = useState('')
  const [abierto, setAbierto] = useState(false)
  const [pos, setPos] = useState(null)
  const caja = useRef(null)
  const input = useRef(null)

  useEffect(() => {
    if (!abierto) return
    const fuera = e => { if (!caja.current?.contains(e.target)) setAbierto(false) }
    const cerrar = () => setAbierto(false)
    document.addEventListener('mousedown', fuera)
    window.addEventListener('scroll', cerrar, true)
    window.addEventListener('resize', cerrar)
    return () => {
      document.removeEventListener('mousedown', fuera)
      window.removeEventListener('scroll', cerrar, true)
      window.removeEventListener('resize', cerrar)
    }
  }, [abierto])

  const abrir = () => {
    const r = input.current?.getBoundingClientRect()
    if (r) setPos({ top: r.bottom + 4, left: r.left, width: Math.max(r.width, 280) })
    setAbierto(true)
  }

  const visibles = useMemo(() => {
    const n = norm(q)
    return groups
      .map(g => ({ ...g, options: g.options.filter(o => !n || norm(o.label).includes(n)) }))
      .filter(g => g.options.length)
  }, [groups, q])

  const elegir = (value) => { setAbierto(false); setQ(''); onPick(value) }

  return (
    <div ref={caja}>
      <input ref={input} value={q} placeholder={placeholder}
        onFocus={abrir} onChange={e => { setQ(e.target.value); if (!abierto) abrir() }}
        onKeyDown={e => {
          if (e.key === 'Escape') { setAbierto(false); input.current?.blur() }
          if (e.key === 'Enter' && visibles.length === 1 && visibles[0].options.length === 1) elegir(visibles[0].options[0].value)
        }}
        className="w-full text-xs border border-gray-200 rounded-md px-2 py-1.5 bg-white text-gray-700 placeholder:text-gray-500" />
      {abierto && pos && (
        <div style={{ position: 'fixed', top: pos.top, left: pos.left, width: pos.width }}
          className="z-50 max-h-72 overflow-auto rounded-lg border border-gray-200 bg-white shadow-lg py-1">
          {visibles.length === 0 && <p className="px-3 py-2 text-xs text-gray-400">{vacio}</p>}
          {visibles.map(g => (
            <div key={g.label}>
              <p className="px-3 pt-2 pb-1 text-[10px] font-semibold uppercase tracking-wide text-gray-400">{g.label}</p>
              {g.options.map(o => (
                <button key={o.value} type="button" onMouseDown={e => e.preventDefault()} onClick={() => elegir(o.value)}
                  className="block w-full text-left px-3 py-1.5 text-xs text-gray-800 hover:bg-gray-100">
                  {o.label}
                </button>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
